var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background w-100"},[_c('div',{staticClass:"panel-container"},[(_vm.offer && _vm.offer.id)?_c('coupon',{attrs:{"offer-data":_vm.offer}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }